






























import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin, DialogMixin } from "../../../../system/mixins";

/**
 * TODO: NameInputDialog.vueにほぼ同じ処理があるのでどこかのタイミングで統一したほうが良い
 */
@Component({
  components: {
  }
})
export default class FormatReferenceTreeAddFolderDialog extends Mixins(ModelEditableMixin, DialogMixin) {
  static instanceOfSource(instance: any): instance is FormatReferenceTreeAddFolderDialog {
    return (instance
      && instance.show !== undefined);
  }

  data(): any {
    return {
      result: false,
      folderText: "",
    };
  }
  result: boolean;
  folderText: string;

  get isEnteredFolder(): boolean {
    return (this.folderText.length > 0);
  }

  async show(): Promise<void> {
    return this.showModal(async () => {
      this.result = false;
      this.folderText = "";
      this.$nextTick(() => {
        const element = this.$refs.input as HTMLInputElement;
        element.focus();
      });
      await this.waitHidden();
      if (!this.result || !this.isEnteredFolder) {
        throw new Error();
      }
      this.editingSource = this.folderText;
    });
  }

  addFolder(): void {
    this.result = true;
    this.isVisible = false;
  }

  cancelFolder(): void {
    this.isVisible = false;
  }
}
